  import { action, createRequestTypes } from '../../base';

export const expenseActionTypes = {
  GET_EXPENSE: createRequestTypes('GET_EXPENSE'),
  GET_EXPENSE_BY_ID: createRequestTypes('GET_EXPENSE_BY_ID'),
  CREATE_EXPENSE: createRequestTypes('CREATE_EXPENSE'),
  UPDATE_EXPENSE: createRequestTypes('UPDATE_EXPENSE'),
  DELETE_EXPENSE: createRequestTypes('DELETE_EXPENSE'),
  LINK_EXPENSE: createRequestTypes('LINK_EXPENSE'),
  UNLINK_EXPENSE: createRequestTypes('UNLINK_EXPENSE'),
  //   UPDATE_STATUS_EXPENSE: createRequestTypes('UPDATE_STATUS_EXPENSE'),
  //   UPDATE_EXPENSE_WORKFLOW_STEP: createRequestTypes('UPDATE_EXPENSE_WORKFLOW_STEP'),
  GET_ACCOUNT: createRequestTypes('GET_ACCOUNT'),
  CREATE_ACCOUNT: createRequestTypes('CREATE_ACCOUNT'),
  UPDATE_ACCOUNT: createRequestTypes('UPDATE_ACCOUNT'),
  DELETE_ACCOUNT: createRequestTypes('DELETE_ACCOUNT'),
};

class ExpenseActions {
  getExpense = (tenantId, expenseId, customerId, sellerId, departmentId, page, limit, status, startDate, endDate, searchKeyword) => action(expenseActionTypes.GET_EXPENSE.REQUEST, {
    tenantId, expenseId, customerId, sellerId, departmentId, page, limit, status, startDate, endDate, searchKeyword,
  })

  getExpenseLoading = (getExpenseLoading) => action(expenseActionTypes.GET_EXPENSE.LOADING, {
    getExpenseLoading,
  })

  getExpenseSuccess = (expense) => action(expenseActionTypes.GET_EXPENSE.SUCCESS, {
    expense,
  })

  getExpenseById = (tenantId, expenseId) => action(expenseActionTypes.GET_EXPENSE_BY_ID.REQUEST, {
    tenantId, expenseId,
  })

  getExpenseByIdLoading = (getExpenseByIdLoading) => action(expenseActionTypes.GET_EXPENSE_BY_ID.LOADING, {
    getExpenseByIdLoading,
  })

  getExpenseByIdSuccess = (expenseById) => action(expenseActionTypes.GET_EXPENSE_BY_ID.SUCCESS, {
    expenseById,
  })

  createExpense = (payload, callback) => action(expenseActionTypes.CREATE_EXPENSE.REQUEST, {
    payload, callback,
  })

  createExpenseLoading = (createExpenseLoading) => action(expenseActionTypes.CREATE_EXPENSE.LOADING, {
    createExpenseLoading,
  })

  createExpenseSuccess = (expense) => action(expenseActionTypes.CREATE_EXPENSE.SUCCESS, {
    expense,
  })

  updateExpense = (payload, callback) => action(expenseActionTypes.UPDATE_EXPENSE.REQUEST, {
    payload, callback,
  })

  updateExpenseLoading = (updateExpenseLoading) => action(expenseActionTypes.UPDATE_EXPENSE.LOADING, {
    updateExpenseLoading,
  })

  updateExpenseSuccess = (expense) => action(expenseActionTypes.UPDATE_EXPENSE.SUCCESS, {
    expense,
  })

  deleteExpense = (payload, callback) => action(expenseActionTypes.DELETE_EXPENSE.REQUEST, {
    payload, callback,
  })

  deleteExpenseLoading = (deleteExpenseLoading) => action(expenseActionTypes.DELETE_EXPENSE.LOADING, {
    deleteExpenseLoading,
  })

  deleteExpenseSuccess = (expense) => action(expenseActionTypes.DELETE_EXPENSE.SUCCESS, {
    expense,
  })

  linkExpense = (payload, callback) => action(expenseActionTypes.LINK_EXPENSE.REQUEST, {
    payload, callback,
  })

  linkExpenseLoading = (linkExpenseLoading) => action(expenseActionTypes.LINK_EXPENSE.LOADING, {
    linkExpenseLoading,
  })

  linkExpenseSuccess = (expense) => action(expenseActionTypes.LINK_EXPENSE.SUCCESS, {
    expense,
  })

  unLinkExpense = (expensePaymentId, callback) => action(expenseActionTypes.UNLINK_EXPENSE.REQUEST, {
    expensePaymentId,
    callback,
  });

  unLinkExpenseLoading = (unLinkExpenseLoading) => action(
    expenseActionTypes.UNLINK_EXPENSE.LOADING, {
      unLinkExpenseLoading,
    },
  );

  getAccount = (tenantId, page, limit, searchKeyword, callback) => action(expenseActionTypes.GET_ACCOUNT.REQUEST, {
    tenantId, page, limit, searchKeyword, callback
  })

  getAccountLoading = (getAccountLoading) => action(expenseActionTypes.GET_ACCOUNT.LOADING, {
    getAccountLoading,
  })

  getAccountSuccess = (accounts) => action(expenseActionTypes.GET_ACCOUNT.SUCCESS, {
    accounts,
  })

  createAccount = (payload, callback) => action(expenseActionTypes.CREATE_ACCOUNT.REQUEST, {
    payload, callback,
  })

  createAccountLoading = (createAccountLoading) => action(expenseActionTypes.CREATE_ACCOUNT.LOADING, {
    createAccountLoading,
  })

  updateAccount = (payload, callback) => action(expenseActionTypes.UPDATE_ACCOUNT.REQUEST, {
    payload, callback,
  })

  updateAccountLoading = (updateAccountLoading) => action(expenseActionTypes.UPDATE_ACCOUNT.LOADING, {
    updateAccountLoading,
  })

  deleteAccount = (payload, callback) => action(expenseActionTypes.DELETE_ACCOUNT.REQUEST, {
    payload, callback,
  })

  deleteAccountLoading = (deleteAccountLoading) => action(expenseActionTypes.DELETE_ACCOUNT.LOADING, {
    deleteAccountLoading,
  })
}

export default new ExpenseActions();
